import { render, staticRenderFns } from "./AddInspectionModal.vue?vue&type=template&id=13b45d2c&scoped=true&"
import script from "./AddInspectionModal.vue?vue&type=script&lang=js&"
export * from "./AddInspectionModal.vue?vue&type=script&lang=js&"
import style0 from "./AddInspectionModal.vue?vue&type=style&index=0&id=13b45d2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b45d2c",
  null
  
)

export default component.exports